import React, {useContext, useState} from "react";
import {useHistory} from "react-router-dom"
import {RoutePath} from "../../router/routePath"
import CampaignList, {MaxActiveCampaignsCount} from "./campaignList";
import Button from "../../components/button/button";
import Tab from "../../components/tab/tab";
import {ProviderContext} from "../providerContext";
import {AutomatedCampaignType} from "./dataForActiveCampaign";
import ToolTips, {ToolTipAlign} from "../../components/toolTips/toolTips";
import {ButtonStatus} from "../../components/button/enum";
import {PromptContext} from "../promptContext";
import {MTips} from "../../util/constants";

export enum CampaignListType {
    active,
    archived
}

function Campaign () {
    const [campaignListType, setCampaignListType] = useState<CampaignListType>(CampaignListType.active)
    const [activeCampaignCount, setActiveCampaignCount] = useState<number>(0)
    const history = useHistory()
    const provider = useContext(ProviderContext)
    const {showInfo} = useContext(PromptContext)

    sessionStorage.removeItem("backupDataTemplate")

    const $tab = (
        <div className={"mt-2"}>
            <Tab selectedIndex={campaignListType === CampaignListType.active ? 0 : 1} data={["Active Campaigns", "Archived Campaigns"]} onChange={(idx) => {
                if (idx === 0) {
                    setCampaignListType(CampaignListType.active)
                } else {
                    setCampaignListType(CampaignListType.archived)
                }
            }}/>
        </div>
    )

    const onUpdateCampaignCount = (count: number) => {
        setActiveCampaignCount(count)
    }

    const onNewCampaign = (type?: AutomatedCampaignType) => {
        if (provider.employeeRole === 1) {
            if (type !== undefined) {
                history.push({
                    pathname: RoutePath.newCampaign,
                    search: `?type=${type}`,
                })
            } else {
                history.push(RoutePath.newCampaign)
            }
        } else {
            showInfo(MTips.roleErrorMsg)
        }
    }
    const $newCampaignBtn = () => {
        const disabled = activeCampaignCount >= MaxActiveCampaignsCount
        const $btn = (
            <Button status={disabled ? ButtonStatus.disabled : ButtonStatus.primary} onClick={() => {
                onNewCampaign()
            }} >
                <div className={"flex items-center space-x-2"}>
                    <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 7H8.5V2.5C8.5 1.94781 8.05219 1.5 7.5 1.5H6.5C5.94781 1.5 5.5 1.94781 5.5 2.5V7H1C0.447812 7 0 7.44781 0 8V9C0 9.55219 0.447812 10 1 10H5.5V14.5C5.5 15.0522 5.94781 15.5 6.5 15.5H7.5C8.05219 15.5 8.5 15.0522 8.5 14.5V10H13C13.5522 10 14 9.55219 14 9V8C14 7.44781 13.5522 7 13 7Z" fill="white"/>
                    </svg>
                    <p>New Campaign</p>
                </div>
            </Button>
        )
        if (disabled) {
            return (
                <ToolTips alignStyle={ToolTipAlign.right} tips={`Only ${MaxActiveCampaignsCount} active campaigns can be created.`}>
                    {$btn}
                </ToolTips>
            )
        }
        return $btn
    }

    const $title = (<p className={"text-gary-1 text-2xl font-bold"}>Campaigns</p>)
    return (
        <div className={"w-full px-10 p-6"}>
            <div className={"flex flex-row items-center justify-between mb-2"}>
                <div>
                    {$title}
                    {$tab}
                </div>
                {$newCampaignBtn()}
            </div>
            <CampaignList campaignListType={campaignListType} onNewCampaign={onNewCampaign} onUpdateCampaignCount={onUpdateCampaignCount} />
        </div>
    )
}

export default Campaign
